<script>
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import { mapActions } from 'vuex'

export default {
  name: 'TaskActions',
  props: ['task'],
  methods: {
    ...mapActions({
      updateTask: 'calendarTask/updateTask'
    }),
    launchTaskCopyModal () {
      emitter.emit('taskCopyModalRequested', { task: this.task })
    },
    archiveTask (id) {
      $axios.post(`${id}/archive`, {})
        .then(() => {
          Swal.fire('Zarchiwizowano', 'Przejazd został zarchiwizowany', 'success')
          emitter.emit('taskChanged', { taskId: id })
        })
    },
    cancelTaskCancelation (id) {
      $axios.post(`${id}/UndoCancel`, {})
        .then(() => {
          Swal.fire('Sukces', 'Anulowanie zlecenia zostało wyłączone', 'success')
          emitter.emit('taskChanged', { taskId: id })
        })
    },
    cancelTaskArchivization (id) {
      $axios.post(`${id}/UndoArchive`, {})
        .then(() => {
          Swal.fire('Sukces', 'Archiwizacja została wyłączona', 'success')
          emitter.emit('taskChanged', { taskId: id })
        })
    },
    cancelTask (task) {
      $axios.post(`${task.id}/Cancel`, {})
        .then(() => {
          Swal.fire({
            title: 'Anulowano zlecenie',
            text: `Przejazd ${task.numer_Przejazdu} został anulowany, proszę zaktualizować stawkę`,
            icon: 'info',
            input: 'number',
            inputPlaceholder: 'Proszę wpisać stawkę zlecenia',
            inputValue: task.stawka,
            inputAttributes: {
              step: '0.01'
            },
            confirmButtonText: 'Zatwierdź'
          }).then((result) => {
            if (result.value) {
              this.updateAmount(result.value).then(() => emitter.emit('taskChanged', { taskId: task.id }))
            }
          })
        })
    },

    async updateAmount (amount) {
      await $axios.put(`Task/${this.task.id}`, { szacunkowy_Koszt: amount })
    }
  }
}
</script>

<template>
  <div class="d-flex">
    <button
      :id="`task-copy-button-${task.id}`"
      class="btn btn-light me-2"
      data-bs-toggle="modal"
      data-bs-target="#taskCopyModal"
      @click="launchTaskCopyModal(task)">
      Kopiuj
    </button>

    <button class="btn btn-primary" @click="archiveTask(task.id)" v-if="!task.archived">
      Archiwizuj
    </button>

    <button class="btn btn-primary" @click="cancelTaskArchivization(task.id)" v-else>
      Wyłącz archiwizacje
    </button>

    <div v-if="!task.cancelled">
      <button class="btn btn-danger mx-2" @click="cancelTask(task)" v-if="!task.archived">
        Anuluj
      </button>
    </div>

    <button class="btn btn-danger mx-2" @click="cancelTaskCancelation(task.id)" v-else>
      Wyłącz anulowanie
    </button>
  </div>
</template>
